export default "__VITE_ASSET__Do2$QkPf__"